// extracted by mini-css-extract-plugin
export default {"datePickerClass":"Dashboard_datePickerClass__FDN+S"};